import { ComponentType } from 'react'
import { LucideProps } from 'lucide-react'
import styled from 'styled-components'
import { Colors, Dimensions } from '../../styles'
import { TIconColor } from '../../styles/colors'
import { TIconSize } from '../../styles/dimensions'
import Flex from './Flex'

export type TIconType = ComponentType<LucideProps> | string

const IconContainer = styled.div<{ size: string }>`
    width: ${({ size }) => size};
    height: ${({ size }) => size};
    font-size: ${({ size }) => size};
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    flex-shrink: 0;
`
const ImageContainer = styled.img`
    width: 100%;
    aspect-ratio: 1;
    object-fit: contain;
`
const StyledLucideIcon = styled.svg<{ $dimension: string; hidden?: boolean }>`
    width: ${({ $dimension }) => $dimension};
    height: ${({ $dimension }) => $dimension};
    visibility: ${({ hidden }) => (hidden ? 'hidden' : 'visible')};
    flex-shrink: 0;
`
interface IconProps {
    icon: TIconType
    size?: TIconSize
    color?: TIconColor // should take priority over colorHex
    colorHex?: string
    className?: string
    hidden?: boolean
}
export const Icon = ({ icon, size = 'default', color, colorHex, className, hidden }: IconProps) => {
    const dimension = Dimensions.iconSize[size]
    // priority is color -> colorHex -> black
    const iconColor = color ? Colors.icon[color] : colorHex

    if (typeof icon === 'string')
        return (
            <IconContainer size={dimension} className={className}>
                {!hidden && <ImageContainer src={icon} />}
            </IconContainer>
        )
    const LucideIconComponent = icon
    return (
        <Flex>
            <StyledLucideIcon
                as={LucideIconComponent}
                color={iconColor}
                className={className}
                $dimension={dimension}
                hidden={hidden}
            />
        </Flex>
    )
}
